export class SubtradeChannelFilter {
    public IncludeInactive?: boolean;
}

export default SubtradeChannelFilter;